import(/* webpackMode: "eager" */ "/vercel/path0/apps/portals/src/app/[portalSlug]/error.tsx");
